<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-12 09:01:04
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-07-26 16:09:28
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/productEvaluationInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 产品质量评价信息 -->
<template>
  <div>
    <div class="form-container">
      <div class="form-title">我的产品评价</div>
      <eSteps :step-list="stepList" :is-active="isActive"></eSteps>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">订单信息</div>
      <orderInfo :apply-info="applyInfo" flag="audit"></orderInfo>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">评价信息</div>
      <evaluationInfo :apply-id="applyId" flag :info="applyInfo" type="1"></evaluationInfo>
    </div>

    <div class="form-container">
      <div class="form-title margin-b-20">产品质量评价申请人信息</div>
      <applyInfo :apply-info="applyInfo"></applyInfo>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">发票信息详情</div>
      <invoiceDetailInfo :apply-id="applyId"></invoiceDetailInfo>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">发票邮寄信息</div>
      <invoiceAddressInfo :apply-id="applyId"></invoiceAddressInfo>
    </div>
    <!-- <div class="form-container">
      <div class="form-title margin-b-20">产品质量评价委托协议</div>
      <attachmentInfo :applyInfo="applyInfo"></attachmentInfo>
    </div> -->
    <div v-if="applyStatus === 102 || 103" class="form-container">
      <div class="form-title margin-b-20">审核历史</div>
      <auditHistoryInfo :apply-id="applyId" :apply-status="applyStatus"></auditHistoryInfo>
    </div>
    <div v-if="applyStatus === 101" class="form-container">
      <div class="form-title margin-b-20">审核信息</div>
      <auditForm ref="auditForm" :apply-info.sync="applyInfo"></auditForm>
    </div>
    <div v-if="applyStatus === 101" class="btn-wrap">
      <eui-btn type="secondary" @click="goBack">取消</eui-btn>
      <eui-btn type="primary" @click="submitApplyInfo">提交</eui-btn>
    </div>
    <div v-if="applyStatus !== 101" class="btn-wrap">
      <eui-btn type="secondary" @click="goBack">返回</eui-btn>
    </div>
  </div>
</template>

<script>
import api from '@/modules/projectA/api/evaluation/index';
import Api from '@/modules/projectA/api/ESorganization/index';
import eSteps from '../../../components/common/e-steps.vue';
import evaluationInfo from '../components/evaluativeInfo.vue';
import applyInfo from '../ESapply/component/applyInfo.vue';
import invoiceDetailInfo from '../ESapply/component/invoiceDetailInfo.vue';
import invoiceAddressInfo from '../ESapply/component/invoiceAddressInfo.vue';
import auditHistoryInfo from '../ESapply/component/auditHistoryInfo.vue';
import orderInfo from '../ESapply/component/orderInfo.vue';
import attachmentInfo from '../ESapply/component/attachmentInfo.vue';
import supplierInfo from '../ESapply/component/supplierInfo.vue';
import auditForm from '../ESapply/component/auditForm.vue';

export default {
  components: {
    eSteps,
    evaluationInfo,
    applyInfo,
    invoiceDetailInfo,
    invoiceAddressInfo,
    orderInfo,
    attachmentInfo,
    supplierInfo,
    auditForm,
    auditHistoryInfo,
  },
  data() {
    return {
      handleConfirm: false, // 供应商 信息 里面的 勾选
      isActive: 1,
      stepList: [
        {
          id: 1,
          title: '提交申请',
        },
        {
          id: 2,
          title: '确认申请',
        },
        {
          id: 3,
          title: '支付完成',
        },
        {
          id: 4,
          title: '审核通过',
        },
        {
          id: 5,
          title: '评价完成',
        },
      ],
      // 审核结果 1：通过，2：拒绝
      applyInfo: { remark: '', result: 1 },
      fromRoute: {},
      routeFrom: null,
      applyId: null,
      applyStatus: null,
      info: {},
    };
  },

  computed: {},

  created() {
    console.log(this.$route.query);
    this.applyId = Number(this.$route.query.applyId);
    /* applyStatusList: [
    { name: '全部', id: 104 },
    { name: '待确认', id: 101 },
    { name: '申请驳回', id: 102 },
    { name: '确认通过', id: 103 },
  ], */
    this.applyStatus = Number(this.$route.query.applyStatus);
    console.log(this.applyStatus, 'this.applyStatus');

    this.getEvaluationInfo(this.applyId);
    this.getInfo(this.applyId);
  },
  methods: {
    goBack() {
      this.$router.push({
        path: '/ES/applyConfirm',
      });
    },
    changeConfirm(val) {
      this.handleConfirm = val;
    },
    //  评价申请人信息===========
    async getEvaluationInfo(applyId) {
      const res = await api.getEvaluationApplyDetailNew({
        applyId,
        noProperFlag: true,
        applyStatus: this.applyStatus,
      });
      if (res.code === '200') {
        this.applyInfo = res.data;
      }
    },
    submitApplyInfo() {
      // 调用子组件中的方法 并传入callback函数
      this.$refs.auditForm.submitForm(async (res) => {
        const params = { ...res, applyId: this.applyId };
        const result = await Api.confirmEvaluattionApply(params);
        if (result.code === '200') {
          this.$message.success('审核成功');
          this.$router.push({
            path: '/ES/applyConfirm/',
          });
        }
      });
    },
    getInfo(applyId) {
      Api.getEvaluationApplyDetail({
        applyId,
      }).then((res) => {
        if (res.code === '200') {
          this.info = res.data;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.form-container {
  // 评价信息
  /* ::v-deep {
    .last-table-row {
      display: none;
    }
  } */
  // 订单信息 不要去支持
  ::v-deep {
    .pay-wrap {
      display: none;
    }
  }
}

.margin-b-20 {
  margin-bottom: 20px;
}

.btn-wrap {
  text-align: center;
}
</style>
